export default "__VITE_ASSET__BEvD_FAC__"